// TODO: //welltech.atlassian.net/browse/UPP-285
// @ts-nocheck
import { Extra } from '@sentry/core';
import { ENV } from '@user-portal/helpers';

import { SENTRY_ANALYTIC, SENTRY_APP, SENTRY_AXIOS } from './consts';

export interface ISentry {
  sentryDSN: string;
  env: ENV;
  release?: string;
  tracesSampleRate?: number;
  autoSessionTracking?: boolean;
}

export interface IError {
  name?: string;
  message?: string;
  code?: string;
  stack?: string;
  value?: { code?: string; message?: string | string[] };
  response?: { status: number; config: { url: string } };
}

export type ErrorType = typeof SENTRY_APP | typeof SENTRY_ANALYTIC | typeof SENTRY_AXIOS;

export type TagsType = [string, string][];

export type ExtrasType = Record<string, Extra>;

export enum ERROR_LEVELS {
  CRITICAL = 'fatal',
  ERROR = 'error',
  WARNING = 'warning',
}
